import { useMemo } from 'react';

import { IVariationDetails } from '~/lib/data-contract';
import { useTranslation } from '~/shared/utils/translation/hooks/useTranslation';

export const useImageAltText = (variant: IVariationDetails) => {
	const { translate } = useTranslation();

	return useMemo(() => {
		return translate('product.image.alt-text', {
			name: variant.name,
			brand: variant.brand?.name ?? '',
			color: variant.color?.colorName ?? '',
			material: variant.mainMaterial?.name ?? '',
		});
	}, [variant.name, variant.brand?.name, variant.color?.colorName, variant.mainMaterial?.name]);
};
